const BASE_STAKE = 100;
const GAUGE_SCALE_FACTOR = 3; // Le facteur de zoom pour la jauge

/**
 * Calcule la cote Max "Score Exact" dynamique (Max de la liste * Facteur).
 */
const getDynamicMaxScoreExactOdd = (oddsList) => {
    if (!oddsList || oddsList.length === 0) return 50.0;

    const exactScoresValues = oddsList
        .filter(o => o.marketType === 'EXACT_SCORE')
        .map(o => o.value);

    const maxListedOdd = exactScoresValues.length > 0
        ? Math.max(...exactScoresValues)
        : 10.0;

    return maxListedOdd * GAUGE_SCALE_FACTOR;
};

/**
 * Calcule la cote Max "Vainqueur" dynamique (Max de la liste * Facteur).
 */
const getDynamicWinnerOdd = (oddsList) => {
    if (!oddsList || oddsList.length === 0) return 3.0;

    const winValues = oddsList
        .filter(o => ['HOME_WINNER', 'AWAY_WINNER', 'DRAW'].includes(o.marketType))
        .map(o => o.value);

    const maxListedOdd = winValues.length > 0
        ? Math.max(...winValues)
        : 1.0;

    return maxListedOdd * GAUGE_SCALE_FACTOR;
};

/**
 * Calcule le TOTAL MAXIMALE pour la jauge (Plafond).
 */
export const calculateMaxPotential = (oddsList) => {
    if (!oddsList || !Array.isArray(oddsList) || oddsList.length === 0) {
        return 10000;
    }

    const dynScore = getDynamicMaxScoreExactOdd(oddsList);
    const dynWinner = getDynamicWinnerOdd(oddsList);

    const totalMaxOdd = dynScore + dynWinner; // Somme des cotes

    return Math.round(totalMaxOdd * BASE_STAKE);
};

/**
 * Calcule les gains réels pour le score choisi.
 */
export const calculatePotentialGains = (userScore, oddsList) => {
    // Sécurité anti-crash
    if (!oddsList) return {total: 0, win: 0, score: 0, oddsWin: 1, oddsScore: 1, max: 10000};

    const {team1, team2} = userScore;

    // 1. On cherche la cote exacte
    const exactLabel = `${team1}:${team2}`;
    const exactOddObj = oddsList.find(o => o.marketType === 'EXACT_SCORE' && o.label === exactLabel);

    // 2. On calcule le Max (toujours utile pour la jauge et le fallback)
    const maxPotential = calculateMaxPotential(oddsList);

    let valScore;
    let valWin;
    let total;

    // --- CAS 1 : Score NON listé (Pari fou / Jackpot) ---
    if (!exactOddObj) {
        // On applique les valeurs MAXIMALES dynamiques
        // Cela permet d'avoir Total = MaxPotential -> Jauge à 100%
        valScore = getDynamicMaxScoreExactOdd(oddsList);
        valWin = getDynamicWinnerOdd(oddsList);

        total = maxPotential;
    }
    // --- CAS 2 : Score listé (Pari classique) ---
    else {
        // ATTENTION : Ici il faut bien prendre .value !
        valScore = exactOddObj.value;

        // On cherche le vainqueur correspondant au score
        let marketType = 'DRAW';
        if (team1 > team2) marketType = 'HOME_WINNER';
        if (team2 > team1) marketType = 'AWAY_WINNER';

        const winOddObj = oddsList.find(o => o.marketType === marketType);
        valWin = winOddObj ? winOddObj.value : 3.0;

        total = Math.round(BASE_STAKE * valWin) + Math.round(BASE_STAKE * valScore);
    }

    return {
        total: total,
        win: Math.round(BASE_STAKE * valWin),
        score: Math.round(BASE_STAKE * valScore),
        oddsWin: Number(valWin).toFixed(2),
        oddsScore: Number(valScore).toFixed(2),
        max: maxPotential
    };
};